module.exports = __webpack_public_path__ + "static/media/sTst.9e665bc5.png";